export const SHOW_FLASH_MESSAGE = 'SHOW_FLASH_MESSAGE';
export const HIDE_FLASH_MESSAGE = 'HIDE_FLASH_MESSAGE';

export const showFlashMessage = (message, options) => {
  return {
    type: SHOW_FLASH_MESSAGE,
    payload: message,
    meta: options,
  };
};

export const hideFlashMessage = () => {
  return {
    type: HIDE_FLASH_MESSAGE,
  };
};
